import React from 'react';
import { withLinkStore, ACTION_TYPES_IS_SKIP_SPLASH_SCREEN } from '../app/reducers';
import CustomFooter from './customFooter';
import { setUniqueInteractionCookie, setGDPRCookie } from '../commonUtil/cookieUtil';

const ExplicitSplashScreen = (props) => {
    const { setShowExplicitSplash, linkDispatch } = props;
    const { linkBasicInfo, gdprSetting, hasCustomFooter } = props.linkStore;
    const { isPasswordRequired, isExpired } = linkBasicInfo || {};
    const onClickImage = () => {
        if (!isPasswordRequired || isExpired) {
            setUniqueInteractionCookie();
            setGDPRCookie();
            linkDispatch({ type: ACTION_TYPES_IS_SKIP_SPLASH_SCREEN, payload: true });
        }

        if (window.mscc) {
            window.mscc.setConsent();
        }

        setShowExplicitSplash(false);
    };

    return (
        <div className="seismic-engagement-explicit-splash">
            { gdprSetting.microsoftDisclaimerMarkup && gdprSetting.microsoftDisclaimerMarkup.GDPRContent &&
                <div className="-splash-header" dangerouslySetInnerHTML={{ __html: gdprSetting.microsoftDisclaimerMarkup.GDPRContent }} />}
            <div className="-splash-bg-image"
                style={{ backgroundImage: `url(${gdprSetting.microsoftBackgroundImageUrl})` }}
                onClick={onClickImage} />
            { hasCustomFooter && <CustomFooter /> }
        </div>
    );
};

export default withLinkStore(ExplicitSplashScreen);
